import { Routes } from '@angular/router';
import { BookingListComponent } from '../components/booking-list/booking-list';
import { BookingViewComponent } from '../components/booking-view/booking-view';
import { AuthenticatedLayout } from './authenticated-layout/authenticated-layout.component';
import { PublicLayoutComponent } from './public-layout/public-layout.component';
import { Onboarding } from '../components/onboarding-component/onboarding-component';
import { AuthGuard } from './auth-guard/auth-guard';
import { LoginComponent } from '../components/login-component/login-component';
import { ForgotPasswordEmail } from '../components/forgot-password-component/forgot-password-email/forgot-password-email';
import { OnboardingVerifyOtp } from '../components/onboarding-component/onboarding-verify-otp/onboarding-verify-otp';
import { DoctorOnboardingComponent } from '../components/onboarding-component/doctor-onboarding-component/doctor-onboarding-component';
import { DoctorDashboard } from '../components/doctor-dashboard/doctor-dashboard';
import { MessagingComponent } from '../components/messaging-component/messaging-component';
import { PatientsView } from '../components/patients-view/patients-view';
import { ChangePassword } from '../components/change-password/change-password';
import { StatsComponent } from '../components/stats-component/stats-component';
import { ForgotPasswordChange } from '../components/forgot-password-component/forgot-password-change/forgot-password-change';
import { ForgotPasswordOtp } from '../components/forgot-password-component/forgot-password-otp/forgot-password-otp';
import { CreatePatient } from '../components/create-patient/create-patient';
import { CreateMedicalRecord } from '../components/create-medical-record/create-medical-record';
import { ViewPatientMedicalHistory } from '../components/view-patient-medical-history/view-patient-medical-history';
import { PatientDetailsView } from '../components/patient-details-view/patient-details-view';
import { ClinicOnboarding } from '../components/clinic-onboarding/clinic-onboarding';
import { ManagerDashboard } from '../components/manager-dashboard/manager-dashboard';
import { InviteClinicUser } from '../components/invite-clinic-user/invite-clinic-user';
import { UserOnboarding } from '../components/user-onboarding/user-onboarding';
import { CreateBooking } from '../components/create-booking/create-booking';
import { PermissionGuard } from '../core/guards/permission.guard';
import { Permissions } from '../core/enums/permissions.enum';
import { CreateClinicEmployee } from '../components/create-clinic-employee/create-clinic-employee';
import { ReceptionDashboard } from '../components/reception-dashboard/reception-dashboard';
import { Settings } from '../components/settings/settings';
import { ProfileView } from '../components/profile-view/profile-view';
import { StaffMessagingComponent } from '../components/staff-messaging/staff-messaging';
import { OtpLogin } from '../components/otp-login/otp-login';

export const routes: Routes = [
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      { path: '', component: LoginComponent },
      { path: 'login', component: LoginComponent },
      { path: 'otp-login', component: OtpLogin },
      { path: 'register', component: Onboarding },
      { path: 'forgot-password', component: ForgotPasswordEmail },
      { path: 'otp-verification/:userId', component: OnboardingVerifyOtp },
      { path: 'forgot-password-change', component: ForgotPasswordChange },
      { path: 'forgot-password-otp', component: ForgotPasswordOtp },
      { path: 'clinic-onboarding', component: ClinicOnboarding },
    ],
  },
  {
    path: 'dashboard',
    component: AuthenticatedLayout,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'booking-list',
        component: BookingListComponent,
        canActivate: [PermissionGuard],
        data: { permission: Permissions.SCHEDULING },
      },
      {
        path: 'view-booking',
        component: BookingViewComponent,
        canActivate: [PermissionGuard],
        data: { permission: Permissions.SCHEDULING },
      },
      {
        path: 'doctor-onboard',
        component: DoctorOnboardingComponent,
        canActivate: [PermissionGuard],
        data: { permission: Permissions.SCHEDULING },
      },
      {
        path: 'doctor-dashboard',
        component: DoctorDashboard,
        canActivate: [PermissionGuard],
        data: { permission: Permissions.SCHEDULING },
      },
      {
        path: 'chat-messages',
        component: MessagingComponent,
        canActivate: [PermissionGuard],
        data: { permission: Permissions.SCHEDULING },
      },
      {
        path: 'patients-view',
        component: PatientsView,
        canActivate: [PermissionGuard],
        data: { permission: Permissions.VIEW_PATIENTS },
      },
      {
        path: 'change-password',
        component: ChangePassword,
        canActivate: [PermissionGuard],
        data: { permission: Permissions.SCHEDULING },
      },
      {
        path: 'stats',
        component: StatsComponent,
        canActivate: [PermissionGuard],
        data: { permission: Permissions.SCHEDULING },
      },
      {
        path: 'create-patient',
        component: CreatePatient,
        canActivate: [PermissionGuard],
        data: { permission: Permissions.SCHEDULING },
      },
      {
        path: 'edit-patient/:patientId',
        component: CreatePatient,
        canActivate: [PermissionGuard],
        data: { permission: Permissions.SCHEDULING },
      },
      {
        path: 'patient/medical-file/:id',
        component: CreateMedicalRecord,
        canActivate: [PermissionGuard],
        data: { permission: Permissions.SCHEDULING },
      },
      {
        path: 'patient/medical-history/:patientId',
        component: ViewPatientMedicalHistory,
        canActivate: [PermissionGuard],
        data: { permission: Permissions.SCHEDULING },
      },
      {
        path: 'patient/details',
        component: PatientDetailsView,
        canActivate: [PermissionGuard],
        data: { permission: Permissions.SCHEDULING },
      },
      {
        path: 'manager-dashboard',
        component: ManagerDashboard,
        canActivate: [PermissionGuard],
        data: { permission: Permissions.BILLING },
      },
      {
        path: 'invite-doctor',
        component: InviteClinicUser,
        canActivate: [PermissionGuard],
        data: { permission: Permissions.USER_ONBOARDING },
      },
      {
        path: 'onboard-users',
        component: UserOnboarding,
        canActivate: [PermissionGuard],
        data: { permission: Permissions.USER_ONBOARDING },
      },
      {
        path: 'create-booking',
        component: CreateBooking,
        canActivate: [PermissionGuard],
        data: { permission: Permissions.SCHEDULING },
      },
      {
        path: 'create-clinic-employee',
        component: CreateClinicEmployee,
        canActivate: [PermissionGuard],
        data: { permission: Permissions.USER_ONBOARDING },
      },
      {
        path: 'reception-dashboard',
        component: ReceptionDashboard,
        canActivate: [PermissionGuard],
        data: { permission: Permissions.SCHEDULING },
      },
      {
        path: 'settings',
        component: Settings,
        canActivate: [PermissionGuard],
        data: { permission: Permissions.SCHEDULING },
      },
      {
        path: 'profile',
        component: ProfileView,
        canActivate: [PermissionGuard],
        data: { permission: Permissions.SCHEDULING },
      },
      {
        path: 'staff-chat',
        component: StaffMessagingComponent,
        canActivate: [PermissionGuard],
        data: { permission: Permissions.SCHEDULING },
      },
      {
        path: 'reporting',
        loadComponent: () =>
          import('../components/reporting-view/reporting-view').then((m) => m.ReportingView),
        canActivate: [PermissionGuard],
        data: { permission: Permissions.SCHEDULING },
      },
      {
        path: 'manage-users',
        loadComponent: () =>
          import('../components/settings/manage-users/manage-users').then((m) => m.ManageUsers),
        canActivate: [PermissionGuard],
        data: { permission: Permissions.MANAGER },
      },
      {
        path: 'pricing-settings',
        loadComponent: () =>
          import('../components/settings/pricing-settings/pricing-settings').then(
            (m) => m.PricingSettings,
          ),
        canActivate: [PermissionGuard],
        data: { permission: Permissions.SCHEDULING },
      },
    ],
  },
  // Catch-all route: redirect unknown paths to login
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
